<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <form @submit.prevent="canEdit ? onSubmit():null">
            <div class="card-body">

                <div class="row">
                    <div class="col-sm-6 col-lg-4 col-sm-6 form-group">
                        <label for="Business">Business</label>
                        <TheMask :class="{'is-invalid': $v.businessNumber.number.$invalid}" :disabled="!canEdit"
                                 :masked="false" autocomplete="off"
                                 class="form-control"
                                 mask="(###) ###-####" maxlength="14"
                                 placeholder="Number" type="tel" v-model="businessNumber.number"/>
                        <span class="invalid-feedback" v-if="$v.businessNumber.number.$invalid">Field is invalid</span>
                    </div>
                    <div class="col-sm-6 col-lg-4 col-sm-6 form-group">
                        <label for="Extension">Ext.</label>
                        <input :disabled="!canEdit" autocomplete="off" class="form-control" maxlength="5"
                               placeholder="Extension" type="text"
                               v-model="businessNumber.extension"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6 col-lg-4 col-sm-6 form-group">
                        <label for="Fax">Fax</label>
                        <TheMask :class="{'is-invalid': $v.faxNumber.number.$invalid}" :disabled="!canEdit"
                                 :masked="false" autocomplete="off"
                                 class="form-control" mask="(###) ###-####" maxlength="14" placeholder="Number"
                                 type="tel"
                                 v-model="faxNumber.number"
                        />
                        <span class="invalid-feedback" v-if="$v.faxNumber.number.$invalid">Field is invalid</span>
                    </div>
                </div>

            </div>
            <div class="card-footer d-print-none text-right">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit" v-if="canEdit">Save</button>
                <RouterLink :disabled="isSubmitting" :to="{name:'Organizations'}" class="btn btn-danger">Back
                </RouterLink>
            </div>
        </form>

    </AppLoadingContainer>
</template>

<script>
    import PhoneNumberService from "@/services/PhoneNumberService";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {maxLength, minLength} from "vuelidate/lib/validators";
    import {TheMask} from "vue-the-mask";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            AppLoadingContainer,
            TheMask
        },
        data() {
            return {
                phoneNumbers: [],
                isLoaded: false,
                isSubmitting: false,
                businessNumber: {},
                faxNumber: {}
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.NetworkAdministrator);
            }
        },
        methods: {
            onSubmit() {
                if (!this.canEdit)
                    return;

                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                PhoneNumberService.UpdateOrganizationPhoneNumbers(vm.organizationId, [vm.faxNumber, vm.businessNumber])
                    .then(() => {
                        vm.alert(ToastType.Success, "The phone numbers was successfully updated")
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => {
                    vm.isSubmitting = false;
                })
            }
        },
        created() {
            const vm = this;

            PhoneNumberService.getOrganizationPhoneNumbers(vm.organizationId)
                .then(response => {
                    vm.phoneNumbers = response;

                    vm.faxNumber = vm.phoneNumbers.find(el => el.phoneType === 'Fax');
                    vm.businessNumber = vm.phoneNumbers.find(el => el.phoneType === 'Business');

                    // Note: We are adding "Missing" phone types
                    if (!vm.businessNumber)
                        vm.businessNumber = {
                            phoneType: 'Business',
                            number: null,
                            extension: null,
                            areaCode: null,
                        };

                    if (!vm.faxNumber)
                        vm.faxNumber = {
                            phoneType: 'Fax',
                            number: null,
                            extension: null,
                            areaCode: null,
                        };

                    // We need to concatenate the area code with the number retrieved from the API
                    if (vm.businessNumber.number)
                        vm.businessNumber.number = vm.businessNumber.areaCode + vm.businessNumber.number;

                    if (vm.faxNumber.number)
                        vm.faxNumber.number = vm.faxNumber.areaCode + vm.faxNumber.number;

                }).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true)
        },
        validations: {
            businessNumber: {
                number: {
                    minLength: minLength(10),
                    maxLength: maxLength(10)
                }
            },
            faxNumber: {
                number: {
                    minLength: minLength(10),
                    maxLength: maxLength(10)
                }
            }
        }
    }
</script>
